import { useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import { Switch } from "../../ui/Switch"
import { EditablePanel } from "./EditablePanel"
import incorrect from "../../../assets/audio/incorrect.mp3"
import toast from "react-hot-toast"

const models = {
  h: [
    require("../../../assets/img/seaanimals/ships/2h.png").default,
    require("../../../assets/img/seaanimals/ships/3h.png").default,
    require("../../../assets/img/seaanimals/ships/4h.png").default,
    require("../../../assets/img/seaanimals/ships/5h.png").default,
  ],
  v: [
    require("../../../assets/img/seaanimals/ships/2.png").default,
    require("../../../assets/img/seaanimals/ships/3.png").default,
    require("../../../assets/img/seaanimals/ships/4.png").default,
    require("../../../assets/img/seaanimals/ships/5.png").default,
  ],
}

const Model = ({
  len,
  src,
  isUnavailable,
  isHolding,
  onDragStart,
  onDragEnd,
  selected,
  setSelected,
  orientation,
}) => {
  const css =
    "uselectable" +
    (selected === len ? " selected" : "") +
    (isHolding ? " holding" : "") +
    (isUnavailable ? " unavailable" : "") +
    (!isUnavailable ? " draggable" : "")

  const draggable = isUnavailable ? "false" : "true"

  const gridPixelSize = document.querySelector("div.cell")?.clientWidth
  const style =
    orientation === "h"
      ? { height: `${gridPixelSize}px` }
      : { width: `${gridPixelSize}px` }

  const seleccionar = (len) => {
    toast.success("Fish selected")
    setSelected(len)
  }
  return (
    <div
      draggable={draggable}
      onDragStart={!isUnavailable ? onDragStart : undefined}
      onDragEnd={!isUnavailable ? onDragEnd : undefined}
    
      onClick={() => {
        !isUnavailable && !isHolding
          ? seleccionar(len)
          : setSelected(null)
      }}
      data-len={len}
      style={style}>
      <img
        data-len={len}
        alt={`barco-${len}`}
        src={src}
        className={css}
        draggable={draggable}
        selected={selected}
      />
    </div>
  )
}

export const SeaAnimalsEditor = ({
  size,
  setConfig,
  animations,
  setAnimations,
}) => {
  const [orientation, setOrientation] = useState("h")
  const panel = useRef(null)
  const rot = useRef(null)
  const [holding, setHolding] = useState(null)
  const [ships, setShips] = useState([])
  const [cleanGrid] = useState(0)

  const toggleOrientations = () =>
    setOrientation((c) => (c === "h" ? "v" : "h"))

  const allShipsPlaced = (callback) => {
    if (ships.length === 4) {
      return callback()
    }

    new Audio(incorrect).play()
    toast.error(t("games.sea_animals.must_position_fish"))
  }

  const undo = () => {
    if (ships.length)
      setShips((c) => {
        let n = c.slice()
        n.pop()
        return n
      })
  }
  const [selected, setSelected] = useState(null)
  const unavailable = (id) => ships.some((s) => s.len === id)

  const { t } = useTranslation()

  return (
    <>
      <div className={holding || selected ? "hodlin" : ""}>
        <div className="title pt-4">
          {t(`games.sea_animals.position_your_fish`)}
        </div>

        <div className="row py-3 justify-content-md-center">
          <div className="col-lg-6 col-12 px-3">
            <EditablePanel
              el={panel}
              orientation={orientation}
              holding={holding}
              setHolding={setHolding}
              size={size}
              ships={ships}
              cleanGrid={cleanGrid}
              setShips={setShips}
              animations={animations}
              selected={selected}
              setSelected={setSelected}
            />
          </div>
          <div className="col-lg-4 col-12 px-3 pt-5 stack">
            <div
              className={
                "row justify-content-md-center py-3 orientation " + orientation
              }>
              <div className="container-mini models-container">
                {models[orientation].map((model, mix) => (
                  <Model
                    key={mix}
                    len={mix + 2}
                    src={model}
                    isHolding={holding === mix + 2}
                    isUnavailable={unavailable(mix + 2)}
                    onDragStart={() => {
                      setSelected(null)
                      setHolding(mix + 2)
                    }}
                    onDragEnd={() => setHolding(null)}
                    selected={selected}
                    setSelected={setSelected}
                    orientation={orientation}
                  />
                ))}
              </div>

              <div className="container-mini mt-4">
                <center>
                  <button
                    disabled={ships.length === 0}
                    className="btn btn-sm btn-danger mx-2"
                    onClick={() => undo()}>
                    🗑️ {t(`games.sea_animals.undo`)}
                  </button>

                  <button
                    ref={rot}
                    className="btn btn-sm azul"
                    onClick={() => toggleOrientations()}>
                    🔄 {t(`games.sea_animals.rotate`)}
                  </button>
                </center>
              </div>
            </div>

            <div className="d-flex mt-5 mb-3">
              <Switch status={animations} setStatus={setAnimations} />
              <p className="px-2 py-1">
                {t(`games.sea_animals.animated_background`)}
              </p>
            </div>

            <p>
              <button
                className="btn azul"
                onClick={() => allShipsPlaced(() => setConfig(ships))}>
                {t(`games.sea_animals.play`)}
              </button>
            </p>
          </div>
        </div>

        <div id="category-container" className="container-sm container-mini">
          <div className="d-flex justify-content-center align-items-center flex-row"></div>
        </div>
      </div>
    </>
  )
}
